import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  postId: "",
  postType: "",
  mainCategory: "",
  subCategory: "",
  customSubcategory: "",
  postTitle: "",
  postTags: [],
  postKeywordsSuggestions: [],
  description: "",
  range: 10,
  location: "",
  portfolioImages: [],
  isHighlight: false
};

const createPostSlice = createSlice({
  name: "createPost",
  initialState,
  reducers: {
    updatePostData: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetPostData: (state) => {
      return initialState;
    },
  },
});

export const { updatePostData, resetPostData } = createPostSlice.actions;
export default createPostSlice.reducer; 